import React from 'react';
import { useTranslation } from 'react-i18next';
import { useBouncer } from 'bouncer';

import Loader from '../../../common/elements/Loader/Loader';
import backgroundImage from '../../../images/login-background-custom.jpg';
import { NSPG_USER } from '../../../services/i18n/namespaces';
const unknownUserStyle = {
  display: 'flex',
  justifyContent: 'center',
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  zIndex: 99,
  boxShadow: '0 0 5px 0 rgba(0,0,0,0.3)',
  padding: '16px',
  backgroundColor: '#31465F',
  fontSize: '14px',
  color: '#fff',
  boxSizing: 'border-box'
};

const backgroundStyle = {
  backgroundImage: `url(${backgroundImage})`,
  backgroundSize: 'contain',
  display: 'flex',
  height: '100vh',
  justifyContent: 'center',
  textAlign: 'center',
  verticalAlign: 'center',
  color: 'white'
};

const buttonStyle = {
  backgroundColor: 'white',
  color: '#31465f',
  borderStyle: 'solid',
  borderWitdth: '1px',
  borderRadius: '4px',
  borderColor: 'white',
  marginLeft: '1rem'
};

const loaderStyle = {
  position: 'relative',
  top: '50%'
};

const NoUser = ({ isUnknownUser, needsSync }) => {
  const { t } = useTranslation();
  const { isAccessTokenReceived, bouncerLogout } = useBouncer();
  return (
    <div style={backgroundStyle}>
      {(isAccessTokenReceived && isUnknownUser && (
        <div style={unknownUserStyle}>
          <span>
            {(needsSync && <React.Fragment>{t(`${NSPG_USER}:accountGenerationInProgress`)}</React.Fragment>) || (
              <React.Fragment>
                {t(`${NSPG_USER}:noAccessMessage`)}{' '}
                <a
                  href="https://elligodirect.atlassian.net/servicedesk/customer/portal/8"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {t(`${NSPG_USER}:support`)}
                </a>{' '}
                {t(`${NSPG_USER}:toRequestAccess`)}
              </React.Fragment>
            )}
            <button style={buttonStyle} onClick={() => bouncerLogout()}>
              {t(`${NSPG_USER}:clickHereToReturnToLoginPage`)}
            </button>
          </span>
        </div>
      )) || (
        <div style={loaderStyle}>
          <Loader />
        </div>
      )}
    </div>
  );
};

export default NoUser;
